import React from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import LocationProjects from '../contentPages/LocationProjects'

const LocationProjectsScreen = () => {
	const { id } = useParams()
	const userLogin = useSelector(state => state.userLogin)
	const { userInfo } = userLogin

	const { location, loading } = useSelector(state => {
		return {
			loading: state.locations.isLoading,
			success: state.locations.isInitialized,
			location: state.locations.entities[id],
		}
	})

	// TODO: Create skeleton loader
	if (loading) return null

	return <LocationProjects userId={userInfo._id} location={location} />
}

export default LocationProjectsScreen
